import classNames from 'classnames';
import {css} from 'styled-components';

import {blendColors} from '../../../../libs/shared/core/src/models/helpers/colorHelpers';
import {boxShadow} from '../../../../libs/shared/ui/src/theme/themeStyleHelpers';

const selectedClassName = 'cell-base--selected';
export const compactCellBaseHeight = '36px';

export function addCellsCommonStyles(isCompact: boolean) {
  return css`
    &.${selectedClassName} {
      ${(p) => (!isCompact && boxShadow(p.theme, `0px 1px 8px 0px rgba(0, 0, 0, 0.28)`)) || ''};

      &,
      &:hover {
        background-color: ${(p) => p.theme.interactiveContainer};
      }
    }

    &:hover {
      background-color: ${(p) => blendColors(p.theme.greys.shade20, p.theme.alphas.gray10)};
    }

    background-color: ${(p) => p.theme.foreground};
    overflow: hidden;
  `;
}

export function makeCellClassName(baseClassName?: string, isSelected?: boolean) {
  return classNames(baseClassName, {
    [selectedClassName]: isSelected,
  });
}
